<template>
    <div class="mvt-listproperty">
        <mvtShifter v-if="getListings && getListings.length">
            <mvtCardProperty v-for="item in getListings" :query="utmParams" :theme="'style3'" :key="item.propertyId" :data="item" :openWindow="true"/>
        </mvtShifter>
    </div>
</template>

<script src="./search-listonly.js"></script>

<style lang="scss">
    @use "./search-listonly.scss" as *;
</style>
